import { AppBar, IconButton, SwipeableDrawer } from '@mui/material';
import { Box } from '@mui/system';
import Logo from '../Components/Logo';
import PageRoutes from '../Config/PageRoutes';
import classes from '../Style/MobileHeader.scss';
import MenuIcon from '@mui/icons-material/Menu';
import React, { useState } from 'react';
import Menu from '../Components/Menu';
import CommoditiesMenu from '../Components/CommoditiesMenu';
import FeedbackButton from '../Components/FeedbackButton';
import ShareButtons from '../Components/ShareButtons';
import LogoMobile from './../Components/LogoMobile';
import ScientificReport from './../Components/ScientificReport';

const MobileHeader = (props) => {
	const anchor = 'left';
	const [state, setState] = useState({ left: false });

	const toggleDrawer = (open) => (event) => {
		if (
			event &&
			event.type === 'keydown' &&
			(event.key === 'Tab' || event.key === 'Shift')
		) {
			return;
		}
		setState({ ...state, [anchor]: open });
	};

	return (
		<AppBar sx={{ position: 'sticky' }} className='mobileHeader'>
			<Box
				sx={{
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center',
				}}
			>
				<LogoMobile />
				{ (
					<IconButton
						size='large'
						edge='start'
						aria-label='menu'
						sx={{ mr: 2, color: '#22294D' }}
						onClick={toggleDrawer(true)}
					>
						<MenuIcon />
					</IconButton>
				)}
				<SwipeableDrawer
					sx={{ zIndex: 9999999999 }}
					anchor={anchor}
					open={state[anchor]}
					onClose={toggleDrawer(false)}
					onOpen={toggleDrawer(true)}
				>
					<Box
						onClick={toggleDrawer(false)}
						sx={{
							height: '100%',
							display: 'flex',
							flexDirection: 'column',
							justifyContent: 'space-between',
							backgroundColor: '#22294D',
							paddingTop: '2rem',
							overflow:'hidden'
						}}
					>
						
						<Menu path={props.path} />
						<Box>
							
							{/* { <FeedbackButton />} */}
							{ <ShareButtons />}
						</Box>
					</Box>
				</SwipeableDrawer>
			</Box>
			{(PageRoutes.CHAPTER_ONE === props.path ||
				props.path.includes(PageRoutes.COMMODITY_ROOT)) && (
				<Box>
					<CommoditiesMenu />
				</Box>
			)}
		</AppBar>
	);
};

export default MobileHeader;
